// extracted by mini-css-extract-plugin
export default {"editModal":"index_editModal__Y7hLL"};